import { connect } from 'react-redux';
import WalletCardComponent from './WalletCardComponent';
import { getProductByIdSelector } from '../../redux/selectors/balancesWithPrices';
import { baseCurrencyPriceSelector } from 'apex-web/lib/redux/selectors/baseCurrenciesSelectors';
import { selectPositionAndSave } from 'apex-web/lib/redux/actions/positionActions';
import { isSelectedAccountRetirementSelector } from '../../redux/selectors/accountSelectors';

const mapStateToProps = (state, ownProps) => {
  const isSelectedAccountRetirement = isSelectedAccountRetirementSelector(
    state
  );

  const {
    iconFileName,
    ProductSymbol,
    ProductFullName,
    Amount,
    rawAmount,
    ProductType,
    ProductId,
    productColor,
    NotionalValue,
    NotionalProductSymbol,
    DepositEnabled,
    WithdrawEnabled
  } = getProductByIdSelector(state, ownProps.productId);
  const baseCurrency = baseCurrencyPriceSelector(state, ownProps.productId);
  const isCrypto = ProductType === 'CryptoCurrency';
  const showNotionalValue = NotionalValue && NotionalProductSymbol;

  const isDepositAllowed = DepositEnabled && !isSelectedAccountRetirement;
  const isWithdrawAllowed = WithdrawEnabled && !isSelectedAccountRetirement;

  return {
    iconFileName,
    ProductSymbol,
    ProductFullName,
    Amount,
    rawAmount,
    isCrypto,
    ProductId,
    productColor,
    baseCurrency,
    NotionalValue,
    NotionalProductSymbol,
    isWithdrawAllowed,
    isDepositAllowed,
    showNotionalValue,
    detailsLink: ownProps.detailsLink
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    selectPositionAndSave: () => {
      dispatch(selectPositionAndSave(ownProps.productId));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletCardComponent);
